import React, { useState } from "react";

import { FontAwesomeIcon }
from "@fortawesome/react-fontawesome";

import {
    faArrowRight,
    faFolder,
    faBuilding,
    faScaleBalanced,
    faHelmetSafety,
    faShieldHalved,
    faScrewdriverWrench,
    faLeaf
}
from "@fortawesome/free-solid-svg-icons";


export default function EvaHomeCard({
    item,
    clickFunction
})
{
	
	console.log("Card Item", item);
    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [hovered, setHovered] =
        useState(false);


    //--------------------------------------------------------
    // EVA icon map
    //--------------------------------------------------------

    const evaIcons =
    {
        "building":
            faBuilding,

        "scale-balanced":
            faScaleBalanced,

        "helmet-safety":
            faHelmetSafety,

        "shield-halved":
            faShieldHalved,

        "screwdriver-wrench":
            faScrewdriverWrench,

        "leaf":
            faLeaf,

        "folder":
            faFolder
    };


    //--------------------------------------------------------
    // Resolve icon
    //--------------------------------------------------------

    const thisIcon =
        evaIcons[item.icon]
        ||
        faFolder;


    //--------------------------------------------------------
    // Image
    //--------------------------------------------------------

    const imageSource =
        item.image
            ?
            `data:${item.imageContentType || "image/jpeg"};base64,${item.image}`
            :
            null;


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div
			className="eva-home-card"
            style={{
                ...cardStyle,

                transform:
                    hovered
                        ? "translateY(-7px)"
                        : "translateY(0)",

                boxShadow:
                    hovered
                        ? "0 18px 45px rgba(50,35,85,0.16)"
                        : "0 8px 28px rgba(31,25,55,0.08)",

                border:
                    hovered
                        ? "1px solid rgba(112,70,216,0.16)"
                        : "1px solid rgba(65,50,100,0.05)"
            }}

            onMouseEnter={() =>
            {
                setHovered(true);
            }}

            onMouseLeave={() =>
            {
                setHovered(false);
            }}

            onClick={() =>
            {
                if(clickFunction)
                {
                    clickFunction(item);
                }
            }}
        >

            {/* ------------------------------------------------
                Image
            ------------------------------------------------ */}

            <div style={imageContainerStyle} className="eva-home-card-image">

                {
                    imageSource
                    &&
                    <img
						className="eva-home-card-image-content"
                        src={imageSource}
                        alt={item.title}
                        style={{
                            ...imageStyle,

                            transform:
                                hovered
                                    ? "scale(1.055)"
                                    : "scale(1)"
                        }}
                    />
                }

            </div>


            {/* ------------------------------------------------
                Icon
            ------------------------------------------------ */}

            <div
				className="eva-home-card-icon"
                style={{
                    ...iconStyle,

                    background:
                        item.colour
                        ||
                        "#6844c7",

                    transform:
                        hovered
                            ? "translateY(-3px) scale(1.06)"
                            : "translateY(0) scale(1)",

                    boxShadow:
                        hovered
                            ? "0 8px 20px rgba(0,0,0,0.18)"
                            : "0 4px 12px rgba(0,0,0,0.10)"
                }}
            >

                <FontAwesomeIcon
                    icon={thisIcon}
                />

            </div>


            {/* ------------------------------------------------
                Content
            ------------------------------------------------ */}

            <div style={contentStyle} className="eva-home-card-content">

                <div style={titleStyle} className="eva-home-card-title">
                    {item.title}
                </div>

                <div style={descriptionStyle} className="eva-home-card-description">
                    {item.description}
                </div>


                {/* Arrow */}

                <div
					className="eva-home-card-arrow"
                    style={{
                        ...arrowStyle,

                        transform:
                            hovered
                                ? "translateX(6px)"
                                : "translateX(0)"
                    }}
                >

                    <FontAwesomeIcon
                        icon={faArrowRight}
                    />

                </div>

            </div>

        </div>
    );
}



//============================================================
// Styles
//============================================================

const cardStyle =
{
    position:
        "relative",

    minWidth:
        0,

    background:
        "#ffffff",

    borderRadius:
        "14px",

    overflow:
        "hidden",

    boxShadow:
        "0 8px 28px rgba(31,25,55,0.08)",

    border:
        "1px solid rgba(65,50,100,0.05)",

    cursor:
        "pointer",

    transition:
        "transform 240ms ease, " +
        "box-shadow 240ms ease, " +
        "border 240ms ease"
};



//============================================================
// Image
//============================================================

const imageContainerStyle =
{
    width:
        "100%",

    height:
        "175px",

    background:
        "linear-gradient(135deg,#eeeaf8,#f8f7fb)",

    overflow:
        "hidden"
};


const imageStyle =
{
    width:
        "100%",

    height:
        "100%",

    objectFit:
        "cover",

    display:
        "block",

    transition:
        "transform 450ms cubic-bezier(0.2, 0.8, 0.2, 1)"
};



//============================================================
// Icon
//============================================================

const iconStyle =
{
    position:
        "absolute",

    top:
        "150px",

    left:
        "22px",

    width:
        "48px",

    height:
        "48px",

    display:
        "flex",

    alignItems:
        "center",

    justifyContent:
        "center",

    borderRadius:
        "12px",

    border:
        "3px solid #ffffff",

    boxShadow:
        "0 4px 12px rgba(0,0,0,0.10)",

    color:
        "#ffffff",

    fontSize:
        "18px",

    transition:
        "transform 220ms ease, " +
        "box-shadow 220ms ease"
};



//============================================================
// Content
//============================================================

const contentStyle =
{
    position:
        "relative",

    minHeight:
        "105px",

    padding:
        "34px 22px 20px 22px"
};


const titleStyle =
{
    marginBottom:
        "7px",

    fontSize:
        "17px",

    fontWeight:
        700,

    color:
        "#17213b"
};


const descriptionStyle =
{
    paddingRight:
        "28px",

    fontSize:
        "13px",

    lineHeight:
        1.45,

    color:
        "#62687b"
};



//============================================================
// Arrow
//============================================================

const arrowStyle =
{
    position:
        "absolute",

    right:
        "20px",

    bottom:
        "20px",

    color:
        "#7046d8",

    fontSize:
        "16px",

    transition:
        "transform 220ms ease"
};